import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import FlexeContext, {FlexeContextValues} from '../contexts/FlexeContext';
import ItemMasterContext, {ItemMasterContextValues} from '../contexts/ItemMasterContext';
import ItemMasterService from './ItemMasterService';
import ItemMasterIndex from './shared/ItemMasterIndex';

export interface Reservation {
  id: number;
  warehouseName: string;
  warehouseCity: string;
}

interface Props {
  authenticityToken: string;
  path: string;
  reservations?: Reservation[];
  showImsAlternateId: boolean;
  useReleaseDate: boolean;
  useSerialNumberProgram: boolean;
  imsBulkUpsertEnabled: boolean;
  imsEnableInnerPack: boolean;
  innerPackCsvEnabled: boolean;
}

function ItemMasterRouter(props: Props) {
  const itemMasterService = new ItemMasterService(props.authenticityToken);
  const isShipper = props.path === 's';

  const flexeContextValue: FlexeContextValues = {
    authenticityToken: props.authenticityToken
  };

  const itemMasterContextValues: ItemMasterContextValues = {
    itemMasterService,
    isShipper
  };

  return (
    <FlexeContext.Provider value={flexeContextValue}>
      <ItemMasterContext.Provider value={itemMasterContextValues}>
        <Router>
          <Switch>
            <Route
              path="/(s|wh)/inventories"
              exact
              strict
              render={(routeProps) => {
                return (
                  <ItemMasterIndex
                    authenticityToken={props.authenticityToken}
                    isShipper={isShipper}
                    reservations={props.reservations}
                    showImsAlternateId={props.showImsAlternateId}
                    useReleaseDate={props.useReleaseDate}
                    useSerialNumberProgram={props.useSerialNumberProgram}
                    imsBulkUpsertEnabled={props.imsBulkUpsertEnabled}
                    imsEnableInnerPack={props.imsEnableInnerPack}
                    innerPackCsvEnabled={props.innerPackCsvEnabled}
                  />
                );
              }}
            />
          </Switch>
        </Router>
      </ItemMasterContext.Provider>
    </FlexeContext.Provider>
  );
}

export default ItemMasterRouter;
